export default __webpack_public_path__ + "static/logo-utuc-fb-fb2acc10c7174b75bb9f82fc610b7817.svg";